export interface ApiResponse<T> {
    result: T;
}

export interface Pagination<T> extends PaginationInterface {
    data: T;
}

export interface PaginationInterface {
    skip: number;
    take: number;
    totalCount: number;
    pageIndex: number;
    perPage: number;
    totalPages: number;
}

export interface PaginationFilterInterface {
    skip: number;
    take: number;
    startDate: string;
    endDate: string;
    paging: boolean;
}

export class PaginationFilterModel {
    skip: number;
    take: number;
    startDate: string;
    endDate: string;
    paging: boolean;

    constructor(private model: PaginationFilterInterface) {
        this.skip = model.skip || 0;
        this.take = model.take || 10;
        this.startDate = model.startDate || '';
        this.endDate = model.endDate || '';
        this.paging = model.paging ?? true;
    }
}
